var render, staticRenderFns
import script from "./common.vue?vue&type=script&lang=js&"
export * from "./common.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a01b02f",
  null
  
)

export default component.exports